<script setup>
import { computed, inject, useAttrs } from "vue";
import { useVModel } from "@vueuse/core";
import { nanoid } from "nanoid";
import { cn } from "~/utils/cn";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  label: { type: String, default: null },
  modelValue: { type: [Boolean, Array, Set, String, Number], default: null },
  value: { type: [String, Number], default: null },
  hideLabel: { type: Boolean, default: false },
  errors: { type: [Array, String], default: () => [] },
});

// Can include form, table, modal
const renderContext = inject("renderContext", []);
const emits = defineEmits(["update:modelValue"]);

const attrs = useAttrs();
const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
});
const id = computed(() => attrs.id || attrs.name || nanoid(8));
const name = computed(() => attrs.name || attrs.id);
const disabled = computed(() => (attrs.disabled || attrs.disabled === "" ? true : undefined));
</script>

<template>
  <div v-tooltip="hideLabel ? label : ''" :class="cn('flex items-center', renderContext.includes('form') && 'my-4', attrs.class)">
    <input
      v-bind="attrs"
      :id="id"
      v-model="modelValue"
      :value="value"
      :name="name"
      :disabled="disabled"
      type="checkbox"
      class="h-4 w-4 rounded-sm border-gray-300 text-blue-600 focus:ring-blue-500 disabled:border-gray-200 disabled:bg-gray-100 disabled:checked:text-black disabled:checked:bg-blue-200 disabled:checked:border-blue-200 disabled:checked:opacity-100 focus:ring-2 focus:ring-offset-2 focus:ring-offset-white peer"
    />
    <label v-if="label && !hideLabel" :for="id" class="ml-2 text-sm font-medium leading-none text-gray-700 peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
      {{ label }}
    </label>
    <BaseErrorList :errors="errors" />
  </div>
</template>
